import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import ScrollProgressBar from '@/components/feature/ScrollProgressBar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import WhyChooseUs from './components/WhyChooseUs';
import FeaturedProducts from './components/FeaturedProducts';
import PortfolioPreview from './components/PortfolioPreview';
import SuccessStories from './components/SuccessStories';
import Testimonials from './components/Testimonials';
import Process from './components/Process';
import FinalCTA from './components/FinalCTA';
import ContactForm from './components/ContactForm';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollProgressBar />
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <WhyChooseUs />
        <FeaturedProducts />
        <PortfolioPreview />
        <SuccessStories />
        <Testimonials />
        <Process />
        <ContactForm />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}